import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["id", "label", "error"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { TextField } from '@cian/text-field-component';
import { PasswordField } from '@cian/password-field-component';
import * as React from 'react';
import { Tooltip } from '../Tooltip';
import * as styles from './styles.css';
export var FormItem = /*#__PURE__*/function (_React$Component) {
  _inherits(FormItem, _React$Component);

  var _super = _createSuper(FormItem);

  function FormItem(props) {
    var _this;

    _classCallCheck(this, FormItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "textField", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      var _this$props = _this.props,
          numeric = _this$props.numeric,
          onKeyDown = _this$props.onKeyDown;

      if (onKeyDown) {
        onKeyDown(event);
      }

      if (numeric) {
        // Управляющие символы
        if ([46, 8, 9, 27, 13, 110].includes(event.keyCode) || [65, 67, 88].includes(event.keyCode) && (event.ctrlKey || event.metaKey) || event.keyCode >= 35 && event.keyCode <= 39) {
          return;
        }

        if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
          event.preventDefault();
        }
      }
    });

    _this.textField = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(FormItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          label = _this$props2.label,
          error = _this$props2.error,
          textFieldProps = _objectWithoutProperties(_this$props2, _excluded);

      return /*#__PURE__*/React.createElement(React.Fragment, null, label ? /*#__PURE__*/React.createElement("label", {
        htmlFor: id,
        className: styles['label']
      }, label) : null, /*#__PURE__*/React.createElement(Tooltip, {
        content: error
      }, textFieldProps.type !== 'password' ? /*#__PURE__*/React.createElement(TextField, _extends({
        ref: this.textField,
        id: id,
        inputStyle: styles['input']
      }, textFieldProps, {
        onKeyDown: this.handleKeyDown
      })) : null, textFieldProps.type === 'password' ? /*#__PURE__*/React.createElement(PasswordField, _extends({
        id: id,
        inputStyle: styles['input']
      }, textFieldProps, {
        onKeyDown: this.handleKeyDown
      })) : null));
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.textField.current) {
        this.textField.current.focus();
      }
    }
  }]);

  return FormItem;
}(React.Component);